import * as actionType from '../constants/constant.action'

export interface SsoLoginState {
  loader: boolean
  sessionToken?: string
  error: string
}

const ssoLoginReducer = (
  state: SsoLoginState,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case actionType.SSO_LOGIN_REQUEST_ASYNC:
      return {
        loader: true,
        error: '',
      }

    case actionType.SSO_LOGIN_REQUEST_FAILURE:
      return {
        ...state,
        error: action.payload,
        loader: false,
      }

    default:
      return {
        ...state,
      }
  }
}

export default ssoLoginReducer
